import Vue from 'vue'
import i18n from '@/i18n';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import Axios from 'axios';
import VueAxios from 'vue-axios';
import VueMeta from 'vue-meta'
import SuiVue from 'semantic-ui-vue';
import VueGtag from 'vue-gtag';
import VueSweetalert2 from 'vue-sweetalert2';
import StorageService from '@/services/StorageService.js';
import './../node_modules/semantic-ui-offline/semantic.min.css';

Vue.use(VueAxios, Axios)
Vue.use(SuiVue)
Vue.use(VueSweetalert2)
Vue.use(VueMeta, { refreshOnceOnNavigation: true })


if (StorageService.isCookieStatisticsAccepted()) {
  Vue.use(VueGtag, { config: { id: "UA-61172700-6" } }, router)
}
Vue.config.productionTip = false

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
